import Modal from '@/components/Modal'
import { createInvite } from '@/services/invites'
import { ChannelHeaderProps as CH } from '@/types'
import { faChevronDown, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { faClipboard } from '@fortawesome/free-solid-svg-icons/faClipboard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useRef, useState } from 'react'

const ChannelHeader: React.FC<CH> = ({ channel }) => {
  const [isDropDownOpen, setIsDrownDownOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const [inviteLink, setInviteLink] = useState('')
  const [show, setShow] = useState(false)
  const [wasClicked, setWasClicked] = useState(false)

  const handleClickOutside = (event: MouseEvent) => {
    if (
      ref.current &&
      event.target instanceof Node &&
      !ref.current.contains(event.target)
    ) {
      setIsDrownDownOpen(false)
      setWasClicked(false)
    }
  }

  const generateInviteCode = async () => {
    if (!channel.id) return
    const invite = await createInvite(channel.id)
    setWasClicked(true)
    setInviteLink(invite.link)
  }

  const handleDeleteChannel = () => {
    if (!channel) return
    // dispatch(deleteChannel(selectedChannel))
    // dispatch(updateSelectedRoom(null))
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="relative text-left" ref={ref}>
      <button
        onClick={() => setIsDrownDownOpen(!isDropDownOpen)}
        className="flex
	items-center
	justify-between
	w-full
	h-16
	bg-gray-800
	text-white
	border-none
	py-2
	px-4
	rounded
	cursor-pointer
	text-2xl
	text-center
	font-medium
	hover:bg-gray-700
	focus:outline-none"
      >
        <span>{channel?.name || 'N/A'}</span>
        <FontAwesomeIcon icon={faChevronDown} className="w-5 h-5 ml-2" />
      </button>

      {isDropDownOpen && (
        <div className="absolute -translate-x-1/2 left-1/2 z-10 mt-2 w-5/6 bg-gray-900 rounded shadow-lg">
          <div className="p-4 text-sm text-white text-center">
            <button
              onClick={() => {
                setShow(true)
              }}
              className="
	      	flex
		px-4
		w-full
		my-2
		items-center
		rouded
		cursor-pointer
		text-lg
		font-normal
		bg-gray-600
		hover:bg-gray-700"
            >
              Invite People
              <FontAwesomeIcon icon={faUserPlus} className="w-5 h-5 ml-auto" />
            </button>
            <button
              className="
		bg-red-700
		text-white
		border-none
		w-full
		my-2
		px-4
		rounded
		cursor-pointer
		text-lg
		font-normal
		hover:bg-red-800"
              onClick={() => handleDeleteChannel()}
            >
              Delete Channel
            </button>
          </div>
        </div>
      )}
      <Modal
        title="Create Invite"
        show={show}
        handleClose={() => {
          setWasClicked(false)
          setShow(false)
        }}
      >
        <div className="p-4 flex flex-col items-center">
          <label className="block mb-2">Generate Code</label>
          <button
            onClick={generateInviteCode}
            className="
            bg-primary
            p-2
            my-2
            text-secondary
            text-lg
            rounded
            cursor-pointer
            hover:bg-primary-dark
          "
          >
            Submit
          </button>
          {inviteLink !== '' ? (
            <div className="relative w-full py-2">
              <input
                type="text"
                value={inviteLink}
                readOnly
                className="w-full p-2 mb-4 border pr-10 cursor-default"
              />
              <button
                onClick={() => navigator.clipboard.writeText(inviteLink)}
                className="absolute top-[38%] right-3 transform -translate-y-1/2"
              >
                <FontAwesomeIcon icon={faClipboard} />
              </button>
            </div>
          ) : (
            wasClicked && (
              <p className="text-red-500">
                Invite link is currently unavailable.
              </p>
            )
          )}
        </div>
      </Modal>
    </div>
  )
}

export default ChannelHeader
